<template>
  <login-form />
</template>

<script>
import LoginForm from '@/components/frontend/Auth/LoginForm.vue'

export default {
  components: { LoginForm },
  layout: 'frontend/auth',
  middleware: 'frontend/notAuth',
  head() {
    return {
      title: 'ログイン',
    };
  },
  async asyncData({ store, redirect, from }) {
    if (store.state.frontend.auth.isLogged) {
      return redirect('/dashboard')
    }

    if (store.state.frontend.auth.isRoleApplication) {
      return redirect('/auth/login-application')
    }

    const arrayApplicationLogin = [
      'landing-url',
      'lp-create',
      'auth-register-application',
    ];

    if (
      store.state.frontend.auth.isRoleApplication
      || (from && arrayApplicationLogin.includes(from.name))
    ) {
      return redirect('/auth/login-application');
    }
  },
};
</script>